import React, { useEffect, useContext, useState } from 'react';
import clsx from 'clsx';

import {
    Grid,
    Card,
    CardHeader,
    CardContent,
    Table,
    TableBody,
    TableRow,
    TableCell,
    Typography,
    Tooltip,
    colors
} from '@material-ui/core';

import {
    FieldError
} from '../../../../common';

import {
    Form,
    Formik,
    Field
} from 'formik';

import {
    Switch,
    TextField
} from 'formik-material-ui';

import { PageContext } from '../PageContext';

import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    root: {
    },
    header: {
        color: colors.blueGrey[500],
        backgroundColor: colors.grey[200]
    },
    content: {
        marginTop: theme.spacing(4)
    },
    field: {
        width: "100%"
    },
    progress: {
        color: "black"
    }
}));

export const TableForm = ({
    formRef,
    errors,
    disabled,
    onSubmit,
    ...props }) => {
    const classes = useStyles();

    const {
        state
    } = useContext(PageContext);

    const {
        table
    } = state;

    const getInitialValues = () => {
        return {
            isDisabled: table.isDisabled,
            allowImport: table.allowImport,
            clearOnImport: table.clearOnImport,
            description: table.description ?? ""
        };
    }

    const getUserNamesList = () => {
        if (table.users && table.users.length > 0) {
            return table.users.map((user, index) =>
                <span key={index}>{user.displayName};&nbsp;</span>
            )
        } else {
            return "No Members";
        }
    }

    const submitClickHandler = (values, actions) => {
        if (onSubmit) onSubmit(values, () => actions.setSubmitting(false));
    }

    return (
        <Card className={clsx(classes.root, props.className)}>
            <CardHeader
                className={classes.header}
                title={
                    <Grid container alignItems="center" justifyContent="space-between">
                        <Grid item>
                            <Typography variant="h6">
                                Table Info
                            </Typography>
                        </Grid>
                    </Grid>
                }
            />
            <CardContent>
                <Formik
                    enableReinitialize
                    initialValues={getInitialValues()}
                    onSubmit={submitClickHandler}
                    innerRef={formRef}>
                    {(props) => {
                        const { values, isSubmitting, handleSubmit } = props;
                        return (
                            <Form noValidate autoComplete="off">
                                <Table>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell style={{ width: "20%" }}>
                                                Name
                                            </TableCell>
                                            <TableCell>
                                                {table.tableName}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                                Is Disabled
                                            </TableCell>
                                            <TableCell>
                                                <Tooltip title={table.isDisabled ? "Table is not available for management" : "Table is available for management"}>
                                                    <span>
                                                        <Field
                                                            name="isDisabled"
                                                            type="checkbox"
                                                            component={Switch}
                                                            disabled={disabled}
                                                        />
                                                    </span>
                                                </Tooltip>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                                Allow Import
                                            </TableCell>
                                            <TableCell>
                                                <Tooltip title={table.allowImport ? "Table allows data import" : "Table do not allow data import"}>
                                                    <span>
                                                        <Field
                                                            name="allowImport"
                                                            type="checkbox"
                                                            component={Switch}
                                                            disabled={disabled}
                                                        />
                                                    </span>
                                                </Tooltip>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                                Total Users
                                            </TableCell>
                                            <TableCell>
                                                {table.users.length}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                                All Users
                                            </TableCell>
                                            <TableCell>
                                                {getUserNamesList()}
                                            </TableCell>
                                        </TableRow>
                                        {table.roles && table.roles.map((role, index) =>
                                        {
                                            return <TableRow key={index}>
                                                <TableCell>
                                                    {role.groupName}
                                                </TableCell>
                                                <TableCell>
                                                    {role.membersCount}
                                                </TableCell>
                                            </TableRow>
                                        }
                                        )}
                                        <TableRow>
                                            <TableCell>
                                                Description
                                            </TableCell>
                                            <TableCell>
                                                <Field
                                                    className={classes.field}
                                                    name="description"
                                                    type="text"
                                                    variant="outlined"
                                                    multiline
                                                    rows={6}
                                                    placeholder="Describe the subject of the table"
                                                    component={TextField}
                                                />
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </Form>
                        );
                    }}
                </Formik>
            </CardContent>
        </Card>
    );
}